<style scoped="scoped" lang="scss">
.yi_curd_table {
  padding: 0 !important;
  margin-top: 10px !important;
}
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table :key="key" class="yi_curd_table" :fixContainerHeight="fixContainerHeight" v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/quality_statistics_details" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xuanzeriqi')">
            <yi_time_input type="datetimerange" :maxTime="365 * 24 * 3600 * 1000" :start.sync="yt.conditions.reportDateStart" :end.sync="yt.conditions.reportDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgIdSelected" :idsPath.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--                :ids.sync="yt.conditions.equipmentId">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
            <!--            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialId">-->
            <!--            </yi_cross_select>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="reset">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_report_equipment_capacity_statistics_production_statistics_statistics_detail",
  props: {
    parentParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      key: 0,
      fixContainerHeight: 1000,
      exceptionTypeList: [],
      columns: [
        {
          label: "shengchangongdanhao",
          prop: "no",
          width: 130,
        },
        {
          label: "ERPgongdanhao",
          prop: "erpNo",
          width: 130,
        },
        {
          label: "shebeimingcheng",
          prop: "equipmentName",
          width: 130,
        },
        {
          label: "mujubianhao",
          prop: "mouldNo",
          width: 130,
        },
        {
          label: "mujumingcheng",
          prop: "mouldName",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "materialCode",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "materialName",
          width: 130,
        },
        {
          label: "gongxugongdan",
          prop: "procedureNo",
          width: 130,
        },
        {
          label: "gongxumiaoshu",
          prop: "procedureDesc",
          width: 130,
        },
        {
          label: "baogongshuliang",
          prop: "quantity",
          width: 130,
        },
        {
          label: "buliangshuliang",
          prop: "badQuantity",
          width: 130,
        },
        {
          label: "jiqijilushuliang",
          prop: "machineQuantity",
          width: 130,
        },
        {
          label: "chayishuliang",
          prop: "diffQuantity",
          width: 130,
        },
        {
          label: "baogongriqi",
          prop: "reportDate",
          type: "time",
          format: "YYYY-MM-DD",
          width: 130,
        },
        {
          label: "baogongbanci",
          prop: "shiftName",
          width: 130,
        },
        {
          label: "tibaoshijian",
          prop: "createTime",
          type: "time",
          width: 130,
        },
        {
          label: "jiqijilukaishishijian",
          prop: "startTime",
          type: "time",
          width: 130,
        },
        {
          label: "jiqijilujieshushijian",
          prop: "endTime",
          type: "time",
          width: 130,
        },

        {
          label: "caozuoren",
          prop: "nickname",
          // width: 130,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt.conditions, "reportDateStart", new Date(this.parentParams.firstDate).getTime());
      this.$set(this.yt.conditions, "reportDateEnd", new Date(this.parentParams.lastDate).getTime());
      this.$set(this.yt.conditions, "orgIdSelected", this.parentParams.orgId);
      this.utils.event_hub.$on("STATISTICS_DETAIL_REFRESH", () => {
        this.$set(this.yt.conditions, "reportDateStart", new Date(this.parentParams.firstDate).getTime());
        this.$set(this.yt.conditions, "reportDateEnd", new Date(this.parentParams.lastDate).getTime());
        this.$set(this.yt.conditions, "orgIdSelected", this.parentParams.orgId);
        setTimeout(() => {
          if (!(this.yt.conditions.reportDateStart == undefined) && !(this.yt.conditions.orgId == undefined)) {
            this.yt.get(1);
          }
        }, 0);
      });
      setTimeout(() => {
        if (!(this.yt.conditions.reportDateStart == undefined) && !(this.yt.conditions.orgId == undefined)) {
          this.yt.get(1);
        }
      }, 0);
      this.getExceptionType();
    }, 300);
  },

  methods: {
    reset() {
      if (this.parentParams.selectedOrgIds !== undefined) {
        this.$set(this.yt.conditions, "materialId", undefined);
        this.$set(this.yt.conditions, "equipmentId", undefined);
        this.$set(this.yt.conditions, "reportDateStart", new Date(this.parentParams.firstDate).getTime());
        this.$set(this.yt.conditions, "reportDateEnd", new Date(this.parentParams.lastDate).getTime());
        this.$set(this.yt.conditions, "orgId", this.parentParams.selectedOrgIds + "");
        this.$set(this.yt.conditions, "orgIdSelected", this.parentParams.orgId);
        this.yt.get(1);
      }
      if (this.yt.conditions !== undefined && this.parentParams.selectedOrgIds == undefined) {
        this.yt.conditions.reportDateStart = undefined;
        this.yt.conditions.reportDateEnd = undefined;
        this.yt.conditions.orgId = undefined;
        this.yt.conditions.orgIdSelected = undefined;
        this.yt.conditions.materialId = undefined;
        this.yt.conditions.equipmentId = undefined;
        ++this.key;
      }
    },
    submitCheckItem(value) {
      this.http
        .post("web/equipment/check/bill/commit", {
          id: value.id,
          remark: value.remark,
          itemList: this.$refs.checkItem.$refs.yt.list,
        })
        .then((res) => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        });
    },
    getExceptionType() {
      this.http
        .get("/web/andon/exceptionType/page", {
          params: {
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          this.exceptionTypeList = res.data.rows;
        });
    },
  },
};
</script>
